import { useState } from "react";
import { useParams } from "react-router-dom";
import { LockClosedIcon } from "@heroicons/react/solid";

import Alert, { ALERT_TYPE } from "./Alert";
import { resetPassword } from "../../utils/api";
import { ReactComponent as ResetPasswordImage } from "../../assets/images/reset.svg";

import Container from "./Container";
import Input from "./Input";

function ResetPassword() {
    const { resetPasswordToken } = useParams();

    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [alert, setAlert] = useState("");
    const [alertType, setAlertType] = useState(ALERT_TYPE.ERROR);

    const handleKeyPress = (key) => {
        if (key === "Enter") handleResetPassword();
    };

    const handleResetPassword = async () => {
        if (newPassword !== confirmNewPassword) {
            setAlert("Please ensure the two passwords entered are identical.");
            setAlertType(ALERT_TYPE.ERROR);
            return;
        }
        try {
            await resetPassword(newPassword, resetPasswordToken);
            setAlert("Your new password is set successfully");
            setAlertType(ALERT_TYPE.SUCCESS);
        } catch (error) {
            setAlertType(ALERT_TYPE.ERROR);
            setAlert(error.message);
        }
    };

    return (
        <Container>
            <div className="hidden lg:flex items-center justify-center w-1/2 p-8 bg-gradient-to-l from-primary-50 to-secondary-50">
                <ResetPasswordImage className="h-56 w-full sm:h-72 md:h-96 lg:h-full xl:h-72" />
            </div>
            <div className="lg:w-1/2 md:full p-8 grid grid-flow-row gap-6">
                <div className="grid grid-flow-row gap-6">
                    <div className="grid-flow-row grid gap-4">
                        <div className="flex items-start justify-between">
                            <h1 className="font-semibold tracking-tight text-3xl text-indigo-900 text-left">
                                Reset Password
                            </h1>
                        </div>
                        <p className="text-left text-gray-500">Create a new password below to login</p>
                    </div>
                    <Alert text={alert} type={alertType} active={alert} close={() => setAlert("")} />
                    <div className="flex">
                        <form className="w-full">
                            <div className="grid grid-flow-row gap-3">
                                <Input
                                    id="new-password"
                                    type="password"
                                    name="New password"
                                    placeholder="Enter new password"
                                    Icon={<LockClosedIcon className="h-4 w-4 text-gray-500" />}
                                    onChange={setNewPassword}
                                    onKeyPress={handleKeyPress}
                                    value={newPassword}
                                />
                                <Input
                                    id="confirm-password"
                                    type="password"
                                    name="Confirm password"
                                    placeholder="Enter password as above"
                                    Icon={<LockClosedIcon className="h-4 w-4 text-gray-500" />}
                                    onChange={setConfirmNewPassword}
                                    onKeyPress={handleKeyPress}
                                    value={confirmNewPassword}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="grid grid-flow-row gap-2">
                        <button
                            className={
                                "block w-full px-3 py-3 " +
                                "bg-primary-600 hover:bg-primary-700 text-white rounded-md " +
                                "focus:bg-primary-700 font-medium focus:outline-none"
                            }
                            onClick={handleResetPassword}
                        >
                            Reset password
                        </button>
                        <p className="text-gray-500 text-sm">
                            Once you have changed your password, please return to your provided login link and enter
                            your username and new password.
                        </p>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default ResetPassword;
